import {
  IEvent,
  EventType,
  BubbleDestroyReason,
  createBubbleDestroyedEvent,
  filterEvents,
} from 'js/bubbleCore/events';
import { getBubbleHandler } from 'js/bubbleCore/bubbles/getBubbleHandler';
import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';

export function resolveShootedBubbleGridCollisions(
  gameBoard: BubbleGameBoard,
): void {
  filterEvents(gameBoard.getEventsQueue(), EventType.ShootingSpaceGridCollision)
    .forEach((event) => {
      const {bubble, colliders} = event.data;
      const handler = getBubbleHandler(bubble);
      handler.onShootedBubbleGridBubbleCollision(gameBoard, bubble, colliders);
      gameBoard.getData().state.firstShoot = true;
    });
};